/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateLocationBrandCatalogAssignmentRequestCatalogType } from './UpdateLocationBrandCatalogAssignmentRequestCatalogType';
import {
    UpdateLocationBrandCatalogAssignmentRequestCatalogTypeFromJSON,
    UpdateLocationBrandCatalogAssignmentRequestCatalogTypeFromJSONTyped,
    UpdateLocationBrandCatalogAssignmentRequestCatalogTypeToJSON,
    UpdateLocationBrandCatalogAssignmentRequestCatalogTypeToJSONTyped,
} from './UpdateLocationBrandCatalogAssignmentRequestCatalogType';

/**
 * 
 * @export
 * @interface UpdateLocationBrandCatalogAssignmentRequest
 */
export interface UpdateLocationBrandCatalogAssignmentRequest {
    /**
     * 
     * @type {UpdateLocationBrandCatalogAssignmentRequestCatalogType}
     * @memberof UpdateLocationBrandCatalogAssignmentRequest
     */
    catalogType: UpdateLocationBrandCatalogAssignmentRequestCatalogType;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationBrandCatalogAssignmentRequest
     */
    integrationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationBrandCatalogAssignmentRequest
     */
    catalogId?: string | null;
}

/**
 * Check if a given object implements the UpdateLocationBrandCatalogAssignmentRequest interface.
 */
export function instanceOfUpdateLocationBrandCatalogAssignmentRequest(value: object): value is UpdateLocationBrandCatalogAssignmentRequest {
    if (!('catalogType' in value) || value['catalogType'] === undefined) return false;
    return true;
}

export function UpdateLocationBrandCatalogAssignmentRequestFromJSON(json: any): UpdateLocationBrandCatalogAssignmentRequest {
    return UpdateLocationBrandCatalogAssignmentRequestFromJSONTyped(json, false);
}

export function UpdateLocationBrandCatalogAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationBrandCatalogAssignmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'catalogType': UpdateLocationBrandCatalogAssignmentRequestCatalogTypeFromJSON(json['catalogType']),
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'catalogId': json['catalogId'] == null ? undefined : json['catalogId'],
    };
}

export function UpdateLocationBrandCatalogAssignmentRequestToJSON(json: any): UpdateLocationBrandCatalogAssignmentRequest {
    return UpdateLocationBrandCatalogAssignmentRequestToJSONTyped(json, false);
}

export function UpdateLocationBrandCatalogAssignmentRequestToJSONTyped(value?: UpdateLocationBrandCatalogAssignmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'catalogType': UpdateLocationBrandCatalogAssignmentRequestCatalogTypeToJSON(value['catalogType']),
        'integrationName': value['integrationName'],
        'catalogId': value['catalogId'],
    };
}

